module.exports = __webpack_public_path__ + "media/images/main_article_post_sp-9292e28b1c2012e3c65569e576fb6d4e.png";